import StyledDiscountChip from './StyledDiscountChip';

export type CampaignDiscountChipProps = {
  campaignChipText?: string;
};

const CampaignDiscountChip: React.FC<CampaignDiscountChipProps> = ({
  campaignChipText
}) => {
  return <StyledDiscountChip>{campaignChipText}</StyledDiscountChip>;
};

export default CampaignDiscountChip;
